/**
 * Get emoji icon for file extension
 */
export const getFileIcon = (extension: string): string => {
  const ext = extension.toLowerCase();
  if (['.pdf'].includes(ext)) {
    return '📄';
  } else if (['.doc', '.docx'].includes(ext)) {
    return '📝';
  } else if (['.xls', '.xlsx'].includes(ext)) {
    return '📊';
  } else if (['.png', '.jpg', '.jpeg', '.gif'].includes(ext)) {
    return '🖼️';
  } else if (['.txt'].includes(ext)) {
    return '📋';
  }
  return '📎';
};

/**
 * Get human-readable file type label
 */
export const getFileTypeLabel = (extension: string): string => {
  const ext = extension.toLowerCase();
  switch (ext) {
    case '.pdf':
      return 'PDF Document';
    case '.doc':
    case '.docx':
      return 'Word Document';
    case '.xls':
    case '.xlsx':
      return 'Excel Spreadsheet';
    case '.png':
    case '.jpg':
    case '.jpeg':
    case '.gif':
      return 'Image File';
    case '.txt':
      return 'Text File';
    default:
      return 'Document';
  }
};

/**
 * Format date string to localized string
 */
export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return 'Unknown';
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return 'Unknown';
  }
};
